import classNames from 'clsx';

import { Text, TextType } from 'ui-components/components/text';

import styles from './styles.module.css';

/**
 * @param {object} props
 * @param {React.ReactNode|import('react-intl').MessageDescriptor} props.children
 * @param {string} [props.className]
 * @returns {JSX.Element}
 */
export const StepInfo = ({ children, className }) => {
  return <Text className={classNames(styles['step-info'], className)} textType={TextType.Paragraph} value={children} />;
};
